// Author : Ayesha Shaikh
//  Create date :-  2025-08-01

import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
  Line,
  Font,
} from "@react-pdf/renderer";
import { useParams } from "react-router-dom";
import { Backdrop, Typography } from "@mui/material";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu4mxP.ttf', // regular
    },
    {
      src: 'https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlfBBc9.ttf', // bold
      fontWeight: 'bold',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
  
    flexDirection: "column",
    padding: 20,
  },
  logo: {
    width: 154,
  },
  section: {
    margin: 1,
    padding: 1,
    flexGrow: 0.1,
  },
 tableHeader: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Roboto",
   
  },
  tableCell: {
    fontSize: 10,
    fontFamily: "Roboto",
    color: "#111",
  },

  header: {
    fontSize: 16,
    fontWeight:600
  
  },
  subheader: {
    fontSize: 10,
    fontWeight: 600,
    marginTop: "5px",
    color: "#5E6470",
  },
 totalText: {
   

   
    marginTop: "7px",
      fontSize: 12,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },

  text: {
    fontSize: 12,
    fontWeight: 600,
    color: "#1A1C21",
    marginTop: "7px",
  },
  table: {
    display: "table",
    width: "auto",
    // borderStyle: 'solid',
    // borderWidth: 1,
    // borderRightWidth: 0,
    // borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderBottomColor: "#BFBFBF",
    borderBottomWidth: 1,
    textAlign: "center",
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    padding: 3,
    // textAlign: "center",
    flex: 1,
  },

  hrLine: {
    width: "100%",
    borderBottomColor: "#D7DAE0",
    borderBottomWidth: 1,
    marginTop: 10,
  },

  nameTitle:{
     fontSize: 10,
    fontWeight: 600,
    color: "black",
    
  },

   subNameTitle:{
      fontSize: 10,
    fontWeight: 600,

    color: "#5E6470",

  }
});

// Define Invoice PDF component
const InvoicePDF = ({ invoiceData }) => (


  <Document>
    <Page size={{ width: 500, height: 600 }}  style={styles.page}>
      <View style={styles.section}>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <Image style={styles.logo} src="/Siec Logo.png" />
          <View>
            <Text style={{ ...styles.header, color: "#555555" }}>Receipt</Text>
            <Text style={{ ...styles.text, color: "#5E6470" }}>
              {invoiceData?.receipt_number}
            </Text>
          </View>
        </View>
         <Line style={styles.hrLine} />

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <View style={{ flexDirection: "column" }}>
          <View  style={{ flexDirection: "row" , alignItems:"center"}}>
            <Text style={styles.nameTitle}>Billed To : </Text>
            <Text style={styles.subNameTitle}>{invoiceData?.enquiry_id?.first_name} {invoiceData?.enquiry_id?.last_name}</Text>
          </View>
          <View style={{ marginTop: "10px" ,flexDirection: "row" , alignItems:"center"}}>
            <Text style={styles.nameTitle}>Branch : </Text>
            <Text style={styles.subNameTitle}>{invoiceData?.enquiry_id?.branch_id?.branch_name}</Text>
           
          </View>

            <View style={{ marginTop: "10px" ,flexDirection: "column" }}>
            <Text style={styles.nameTitle}>Address : </Text>
            
            <Text style={{ marginTop:'6px',...styles.subNameTitle}}>{invoiceData?.enquiry_id?.branch_id?.address}</Text>
            <Text style={{ marginTop:'6px', ...styles.subNameTitle}}>{invoiceData?.enquiry_id?.branch_id?.city_id?.city_name} , {invoiceData?.enquiry_id?.branch_id?.state_id?.state_name}</Text>
          </View>
          </View>

          <View style={{ flexDirection: "column" }}>
            <View style={{ marginTop: "10px" ,flexDirection: "row" , alignItems:"center"}}>
              <Text style={styles.nameTitle}>Receipt Date : </Text>
              <Text style={styles.subNameTitle}>{invoiceData?.paid_date}</Text>
            </View>
            <View style={{ marginTop: "10px" ,flexDirection: "row" , alignItems:"center" }}>
              <Text style={styles.nameTitle}>Paid Date : </Text>
              <Text style={styles.subNameTitle}>{invoiceData?.paid_date}</Text>
            </View>
          </View>
           

       
        </View>
      </View>

{/* Receipt Table Section */}
<View style={{ marginTop: 30 }}>
  <Text style={styles.text}>Receipt Details</Text>
  
  {/* Table Header */}
  <View style={{
    flexDirection: "row",
    backgroundColor: "#F5F5F5",
    borderTop: "1px solid #D7DAE0",
    borderBottom: "1px solid #D7DAE0",
    paddingVertical: 6,
    paddingHorizontal: 4,
    marginTop: 10
  }}>
    <Text style={{ flex: 0.5, ...styles.tableHeader }}>#</Text>
  <Text style={{ flex: 3, ...styles.tableHeader }}>Title / Description</Text>
  <Text style={{ flex: 1.2, ...styles.tableHeader, textAlign: "right" }}>Subtotal</Text>  </View>

  {/* Table Row */}
  <View style={{
    flexDirection: "row",
    borderBottom: "1px solid #D7DAE0",
    paddingVertical: 8,
    paddingHorizontal: 4,
    alignItems: "center"
  }}>
    <Text style={{ flex: 0.5, fontSize: 10, color: "#111" }}>1</Text>

    <View style={{ flex: 3 }}>
      <Text style={{ fontSize: 10, fontWeight: "bold", color: "#111" }}>
        Test Booked - {invoiceData?.test_type_id?.name}
      </Text>
      <Text style={{ fontSize: 9, color: "#5E6470", marginTop: 3 }}>
    {invoiceData?.sub_test_type_id? `(${invoiceData?.sub_test_type_id?.name})` :"" }  
      </Text>
    </View>

    <Text style={{
      flex: 1.2,
      fontSize: 10,
      fontWeight: "bold",
      color: "#333",
      textAlign: "right"
    }}>
       {invoiceData?.paid_amount} {invoiceData?.currency}
    </Text>
  </View>
</View>


      <View
        style={{
          ...styles.section,
          flexDirection: "row",
          justifyContent:"flex-end",
          marginLeft: 10,
          padding: 0,
        }}
      >
        <Text style={{ ...styles.totalText }}>Total : </Text>
        <Text style={{ ...styles.totalText }}>  {invoiceData?.paid_amount} {invoiceData?.currency}</Text>
      </View>



  

<View style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: 20 }}>
  <Image
    src="/warning (2).png" // Use a valid image path
    style={{ width: 15, height: 14, marginRight: 5 }}
  />
  <Text style={{ color: "black", fontWeight: "bold", fontSize: 12 }}>
    NOTE: SIEC Test Masters does not have a refund policy under any circumstances.
  </Text>
</View>

      <View style={{ ...styles.section, marginTop: "30px" }}>
       
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Text style={{ ...styles.subheader, marginRight: "10px" }}>
            Payment info
          </Text>

          <Line style={styles.hrLine} />
        </View>
        <View style={{
            display: "flex",
            flexDirection: "row",
             justifyContent: "space-between",
            marginTop: "20px",
          }}>

    
       
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              // borderRightWidth: 1,
              // borderColor: "black",
              // paddingRight: 10,
              alignItems:"center"
            }}
          >
            <Text style={styles.nameTitle}>Ref Number : </Text>
            <Text style={{ ...styles.subNameTitle}}>
              {invoiceData?.ref_number}
            </Text>
          </View>

          {/* <View
            style={{
              display: "flex",
              flexDirection: "row",
              // borderRightWidth: 1,
              // borderColor: "black",
              // paddingRight: 10,
              alignItems:"center" ,
              marginTop:10
            }}
          >
            <Text style={styles.nameTitle}>Payment Method :  </Text>
            <Text style={{...styles.subNameTitle}}>
              {invoiceData.payment_method?.payment_mode}
            </Text>
          </View> */}

          <View style={{ display: "flex", flexDirection: "row", alignItems:'center' ,      marginTop:10}}>
            <Text style={styles.nameTitle}>Payment Status : </Text>
            <Text style={{...styles.subNameTitle}}>
              {invoiceData.payment_status}
            </Text>
          </View>


            </View>


<View style={{
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
            marginTop: "20px",
          }}>
          <View style={{ width: "200px" }}>
            <Text style={styles.subheader}>
            B-2/9 1st Floor, Opposite Happy Model School, Janakpuri, New Delhi 110058
            </Text>
          </View>
          </View>

             
        </View>

       
      </View>
    </Page>
  </Document>
);


export default function MiscliniousInvoiceForm() {
    const { receiptId } = useParams()
      const [receiptData, setReceiptData] = useState(null)
      const [isLoading, setIsLoading] = useState(false)
      const [error, setError] = useState(null);
 
   console.log("error",error)
    
      useEffect(() => {
        const fetchAdditionalDetails = async (id) => {
          try {
            setIsLoading(true);
            const response = await fetch(`${API_ENDPOINT}mis-receipt/${id}`);
            if (response.ok) {
              const data = await response.json();
              setReceiptData(data);
              setIsLoading(false);
              setError(null)
         
            } else {
              setIsLoading(false);
              setError('Error fetching additional details');
            }
          } catch (error) {
            setIsLoading(false);
            setError('Error fetching additional details');
          }
        };
    
        fetchAdditionalDetails(receiptId);
      }, [receiptId]);
    
    
     
    
  return (
 <>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h2" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <img src='/sand-clock.png' alt="Error" style={{ width: '200px', height: '200px' }} />
      </Backdrop>

      {error && !isLoading &&  (
         <div
         style={{
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'center',
           alignItems: 'center',
           height: '100%',
         }}
       >
          <img src='/browser.png' alt="Error" style={{ width: '200px', height: '200px' }} />
          <Typography variant="h3">Error generating receipt</Typography>
          <Typography variant="h5">Please try again later</Typography>
        </div>
      )}
     {!isLoading && error===null && receiptData?.enquiry_id && (
  <PDFViewer style={{ width: "100%", height: "100vh" }}>
    <InvoicePDF invoiceData={receiptData} />
  </PDFViewer>
)}
    </>
  )
}
